var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68451 2.90625H17.1845C17.6604 2.90625 18.1168 3.0953 18.4533 3.43181C18.7898 3.76832 18.9789 4.22473 18.9789 4.70062V13.2188H4.89014V4.70062C4.89014 4.22473 5.07919 3.76832 5.4157 3.43181C5.75221 3.0953 6.20861 2.90625 6.68451 2.90625Z",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0876 19.7812H4.78326C4.50375 19.807 4.22222 19.7626 3.96418 19.6521C3.70614 19.5417 3.47974 19.3685 3.30548 19.1485C3.13122 18.9284 3.0146 18.6684 2.9662 18.3919C2.91779 18.1154 2.93912 17.8312 3.02826 17.565L4.89014 13.2188H18.9808L20.8445 17.565C20.9337 17.8313 20.9551 18.1157 20.9066 18.3924C20.8581 18.6691 20.7413 18.9292 20.5668 19.1493C20.3923 19.3695 20.1657 19.5425 19.9074 19.6529C19.6491 19.7632 19.3673 19.8073 19.0876 19.7812Z",
    fill: "#FFECE2",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93737 28.2188H17.4374C17.9133 28.2188 18.3697 28.4078 18.7062 28.7443C19.0427 29.0808 19.2317 29.5372 19.2317 30.0131V38.5313H5.1355V30.0131C5.1355 29.7769 5.18216 29.5429 5.2728 29.3247C5.36345 29.1065 5.49629 28.9084 5.66371 28.7417C5.83113 28.5749 6.02982 28.4429 6.24839 28.3532C6.46696 28.2635 6.7011 28.2178 6.93737 28.2188Z",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3332 45.0938H5.02887C4.74935 45.1195 4.46782 45.0751 4.20978 44.9646C3.95174 44.8542 3.72534 44.681 3.55108 44.461C3.37682 44.2409 3.26021 43.9809 3.2118 43.7044C3.1634 43.4279 3.18473 43.1437 3.27387 42.8775L5.13574 38.5312H19.2264L21.0901 42.8775C21.1793 43.1438 21.2007 43.4282 21.1522 43.7049C21.1037 43.9816 20.9869 44.2417 20.8124 44.4618C20.6379 44.682 20.4113 44.855 20.153 44.9654C19.8947 45.0757 19.6129 45.1198 19.3332 45.0938Z",
    fill: "#FFECE2",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7769 3.84375H35.9644V6.65625",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6519 44.1562H35.9644V41.3438",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0938 21.6562H42.2812C42.2812 21.6562 45.0938 21.6562 45.0938 24.4688V32.9062C45.0938 32.9062 45.0938 35.7188 42.2812 35.7188H30.0938C30.0938 35.7188 27.2812 35.7188 27.2812 32.9062V24.4688C27.2812 24.4688 27.2812 21.6562 30.0938 21.6562Z",
    fill: "#FFECE2",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 21.6956V18.8438C29.625 17.1033 30.3164 15.4341 31.5471 14.2034C32.7778 12.9727 34.447 12.2813 36.1875 12.2812C37.928 12.2812 39.5972 12.9727 40.8279 14.2034C42.0586 15.4341 42.75 17.1033 42.75 18.8438V21.6956",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.375 28.6875L35.25 30.5625L39 26.8125",
    stroke: "#FF7125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityDark);
export default __webpack_public_path__ + "static/media/security-dark.558145e69c81d3a8266cef56d19d426d.svg";
export { ForwardRef as ReactComponent };